import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/web/web/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["GradientBalls"] */ "/home/runner/work/web/web/src/components/Backgrounds/GradientBalls.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BlogGrid"] */ "/home/runner/work/web/web/src/components/Blog/BlogGrid.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FeaturedPosts"] */ "/home/runner/work/web/web/src/components/Blog/FeaturedPosts.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SearchAndFilter"] */ "/home/runner/work/web/web/src/components/Blog/SearchAndFilter.tsx");
